module.exports = __webpack_public_path__ + "media/images/chevron-left-df609b21.png";